<template>
  <div>
    <div class="bg flex flex-between item-center">
      <div class="name-wrapper bold">当前供货商: {{ storeNames }}</div>
      <div class="flex item-center">
        <div class="name-wrapper mr10">账户类型</div>
        <el-select v-model="accountType" placeholder="请选择" class="mr20" @change="changeAccountType" size="small">
          <el-option
              v-for="(item, i) in options"
              :key="i"
              :label="item.name"
              :value="item.code">
          </el-option>
        </el-select>
        <div>
<!--          <div class="desc-wrapper">
            对私账户的款项结算到商户的充值中心账户，
          </div>
          <div class="desc-wrapper">
            对公账户的款项分配结算给导购银行卡账户，分成商户添加后该商户的所有申报都会结算对应比例的金额给商户
          </div>-->
          <div class="desc-wrapper">款项分别按对公、对私结算给导购银行卡账户，分成商户添加后该商户的所有申报都会结算对应比例的金额给商户(如果不设置则默认按对公账户)</div>
        </div>
      </div>
    </div>
    <hm-content title="" class="mt10">
      <div class="flex flex-between item-center">
        <el-button size="small" @click="addStoreShare" type="primary"
        >新增分成商户</el-button
        >
        <div class="flex item-center">
          <el-input v-model="searchCondition.storeName" placeholder="请输入商户名称" size="small" class="mr20" clearable></el-input>
          <el-button size="small" @click="search" type="primary"
          >查询</el-button
          >
        </div>
      </div>
      <div class="mt20">
        <el-table
            :data="list"
            stripe
            border
            size="small"
            style="width: 100%">
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              prop="storeName"
              header-align="center"
              align="center"
              label="商户">
          </el-table-column>
          <el-table-column
              prop="shareRatio"
              label="分成比例（每笔红包商户获得的分成，从导购红包金额中扣除）"
              header-align="center"
              align="center">
            <template slot-scope="scope">
              {{ scope.row.shareRatio }}%
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="teams"
              label="操作"
              width="350"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="historyLog(scope.row)"
                >历史记录</el-button
                >
                <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
                >
                <el-button size="small" type="text" @click="del(scope.row)"
                >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </hm-content>
    <el-dialog
        :close-on-click-modal="false"
        title="新增分成商户"
        width="1600px"
        @close="closeDialog"
        :visible.sync="dialogVisible"
    >
      <div class="flex">
        <div class="left-wrapper">
          <div class="flex flex-end item-center">
            <el-input v-model="dialog.store.searchCondition.storeName" placeholder="请输入商户名称" size="small" class="mr20" clearable></el-input>
            <el-button size="small" @click="storeSearch" type="primary"
            >查询</el-button
            >
          </div>
          <div style="margin-top: 70px">
            <el-table
                :data="dialog.store.storeList"
                stripe
                border
                ref="storeListTable"
                size="small"
                @selection-change="storeHandleSelectionChange"
                style="width: 100%">
              <el-table-column
                  type="selection"
                  width="55">
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="index => index + (dialog.store.storeCurrentPage - 1) * dialog.store.storePageSize + 1"
              ></el-table-column>
              <el-table-column
                  prop="storeName"
                  header-align="center"
                  align="center"
                  label="商户">
              </el-table-column>
              <el-table-column
                  prop="shopCount"
                  label="门店数"
                  header-align="center"
                  align="center">
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                  background
                  small
                  :pager-count="5"
                  :total="dialog.store.storeTotal"
                  @current-change="storePaging"
                  @size-change="storeHandleSizeChange"
                  layout="total,sizes,  prev, pager, next, jumper"
                  :current-page="dialog.store.storeCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="centre-wrapper flex item-center flex-center">
          <el-button size="small" @click="selectdStore" type="primary"
          >选择勾选商户</el-button
          >
        </div>
        <div class="flex-1">
          <div class="flex flex-end item-center">
            <el-input v-model="dialog.selected.searchCondition.storeName" placeholder="请输入商户名称" size="small" class="mr20" clearable></el-input>
            <el-button size="small" @click="selectedSearch" type="primary"
            >查询</el-button
            >
          </div>
          <div class="flex flex-end item-center mt20">
            <div class="mr10">批量设置分成比例</div>
            <el-input v-model="dialog.selected.shareRatio" placeholder="请输入" class="mr20" size="small" clearable @blur="batchShareRatio">
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="mt20 table-wrapper">
            <el-table
                :data="dialog.selected.selectedList.filter(
                (data) =>
              !dialog.selected.searchCondition.searchStoreName ||
              data.storeName
              .toLowerCase()
              .includes(dialog.selected.searchCondition.searchStoreName.toLowerCase()) ||
              data.storeName
              .toLowerCase()
              .includes(dialog.selected.searchCondition.searchStoreName.toLowerCase())
              )"
                stripe
                border
                max-height="560"
                ref="selectedTable"
                size="small"
                @selection-change="selectedHandleSelectionChange"
                style="width: 100%">
              <el-table-column
                  type="selection"
                  width="55">
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="index => index + 1"
              ></el-table-column>
              <el-table-column
                  prop="storeName"
                  header-align="center"
                  align="center"
                  label="商户">
              </el-table-column>
              <el-table-column
                  prop="shareRatio"
                  label="分成比例(%)"
                  header-align="center"
                  align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.shareRatio" placeholder="请输入" class="mr20" size="small" clearable>
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="teams"
                  label="操作"
                  width="80"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="delSelected(scope.row)"
                    >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="mt40 flex flex-center">
        <el-button  size="small" @click="dialogVisible = false"
        >取消</el-button
        >
        <el-button type="primary" size="small" @click="submit"
        >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
        :close-on-click-modal="false"
        title="编辑分成商户"
        width="800px"
        :visible.sync="editDialogVisible"
    >
      <el-form :model="row" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="商户名称">
          {{ row.storeName }}
        </el-form-item>
        <el-form-item label="分成比例" prop="shareRatio">
          <el-input v-model="row.shareRatio" placeholder="请输入" class="mr20" size="small" clearable>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="mt40 flex flex-center">
        <el-button  size="small" @click="editDialogVisible = false"
        >取消</el-button
        >
        <el-button type="primary" size="small" @click="submitEdit"
        >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
        :close-on-click-modal="false"
        title="历史记录"
        width="800px"
        :visible.sync="historyLogVisible"
    >
      <div class="mt20">
        <el-table
            :data="dialog.historyLog.historyLogList"
            stripe
            border
            size="small"
            style="width: 100%">
          <el-table-column
              prop="shareRatio"
              label="分成比例"
              header-align="center"
              align="center">
            <template slot-scope="scope">
              {{ scope.row.shareRatio }}%
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              header-align="center"
              align="center"
              label="创建时间">
          </el-table-column>
          <el-table-column
              prop="createBy"
              header-align="center"
              align="center"
              label="创建人">
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="dialog.historyLog.historyLogTotal"
              @current-change="historyLogPaging"
              @size-change="historyLogHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="dialog.historyLog.historyLogCurrentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="mt40 flex flex-center">
        <el-button type="primary"  size="small" @click="historyLogVisible = false"
        >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { arrayUnique2, getSubtract } from "@/utils/utils";
export default {
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchCondition: {
        storeName: ""
      },
      storeNames: "",
      options: [
        {
          code: "corporate",
          name: "对公账户"
        },
        {
          code: "private",
          name: "对私账户"
        }
      ],
      accountType: "",
      currentAccountType: "",
      dialogVisible: false,
      dialog: {
        store: {
          storeList: [],
          storeSelection: [],
          storeCurrentPage: 1,
          storePageSize: 10,
          storeTotal: 0,
          searchCondition: {
            storeName: ""
          }
        },
        selected: {
          selectedList: [],
          selectedSelection: [],
          shareRatio: "",
          searchCondition: {
            storeName: "",
            searchStoreName: ""
          }
        },
        historyLog: {
          historyLogCurrentPage: 1,
          historyLogPageSize: 10,
          historyLogTotal: 0,
          historyLogList: [],
        }
      },
      row: {},
      editDialogVisible: false,
      rules: {
        shareRatio: [
          {
            required: true,
            trrger: "blur",
            message: "请输入分成比例"
          }
        ],
      },
      historyLogVisible: false,
      historyCurrentRow: {},
    };
  },
  created() {},
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.currentAccountType = this.$route.query.accountType;
    this.accountType = this.$route.query.accountType;
    this.queryList();
  },
  methods: {
    historyLogPaging(page) {
      this.dialog.historyLog.historyLogCurrentPage = page;
      this.queryHistoryLogList();
    },
    historyLogHandleSizeChange(size) {
      this.dialog.historyLog.historyLogCurrentPage = 1;
      this.dialog.historyLog.historyLogPageSize = size;
      this.queryHistoryLogList();
    },
    async queryHistoryLogList() {
      let params = {
        pageNo: this.dialog.historyLog.historyLogCurrentPage,
        pageSize: this.dialog.historyLog.historyLogPageSize,
        supplierCode: this.historyCurrentRow.supplierCode,
        storeCode: this.historyCurrentRow.storeCode,
      };
      const { code, result } = await this.$store.dispatch("queryHistoryShareRatioLog", params);
      if (code === "0") {
        const { total, records } = result;
        this.dialog.historyLog.historyLogList = records;
        this.dialog.historyLog.historyLogTotal = total;
      }
    },
    async historyLog(row) {
      this.historyCurrentRow = row;
      this.dialog.historyLog.historyLogCurrentPage = 1;
      this.dialog.historyLog.historyLogPageSize = 10;
      await this.queryHistoryLogList();
      this.historyLogVisible = true;
    },
    selectedSearch() {
      this.dialog.selected.searchCondition.searchStoreName = this.dialog.selected.searchCondition.storeName;
      this.$refs.selectedTable.toggleAllSelection();
    },
    batchShareRatio() {
      this.dialog.selected.selectedSelection.forEach(v => {
        v.shareRatio = this.dialog.selected.shareRatio;
      })
    },
    del(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = JSON.parse(JSON.stringify(row));
        await this.$store.dispatch("delStoreShareConfig", params);
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryList();
      }).catch(() => {

      });
    },
    submitEdit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let params = this.row;
          await this.$store.dispatch("editStoreShareConfig", params);
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.editDialogVisible = false;
          this.queryList();
        }
      });
    },
    edit(row) {
      this.row = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    async submit() {
      let r = /^\+?[1-9][0-9]*$/;
      for (let i = 0; i < this.dialog.selected.selectedList.length; i++) {
        if (!this.dialog.selected.selectedList[i].shareRatio) {
          this.$message({
            message: "请输入分成比例!",
            type: "warning"
          });
          return;
        }
        if (!r.test(this.dialog.selected.selectedList[i].shareRatio)) {
          this.$message({
            message: "分成比例只能设置正整数!",
            type: "warning"
          });
          return;
        }
      }
      let params = [];
      this.dialog.selected.selectedList.forEach(v => {
        params.push({
          supplierCode: this.$route.query.storeCode,
          storeCode: v.storeCode,
          shareRatio: v.shareRatio
        })
      });
      await this.$store.dispatch("submitStoreShareConfig", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.dialogVisible = false;
      this.queryList();
    },
    closeDialog() {
      this.dialog.selected.selectedList = [];
      this.dialog.selected.selectedSelection = [];
      this.dialog.store.storeList = [];
      this.dialog.store.storeSelection = [];
      this.dialog.store.searchCondition.storeName = "";
      this.dialog.selected.shareRatio = "";
      this.dialog.selected.searchCondition.storeName = "";
      this.dialog.selected.searchCondition.searchStoreName = "";
      this.dialogVisible = false;
    },
    delSelected(row) {
      let list = [];
      list.push(row);
      this.dialog.selected.selectedList = getSubtract(
          this.dialog.selected.selectedList,
          list,
          "storeCode"
      );
      this.$refs.selectedTable.toggleAllSelection();
      this.dialog.store.storeList.forEach(v => {
        setTimeout(() => {
          if (row.storeCode == v.storeCode) {
            this.$refs.storeListTable.toggleRowSelection(v, false);
          }
        }, 0);
      })
    },
    storeSearch() {
      this.dialog.store.storeCurrentPage = 1;
      this.queryStoreList();
    },
    querySelectedList() {},
    async queryStoreList() {
      let params = {
        pageNo: this.dialog.store.storeCurrentPage,
        pageSize: this.dialog.store.storePageSize,
        excludeStoreShareFlag: "yes",
        supplierCode: this.$route.query.storeCode,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      }
      const searchCondition = JSON.parse(JSON.stringify(this.dialog.store.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryStoreBasicList", params);
      if (code === "0") {
        const { total, records } = result;
        this.dialog.store.storeList = records;
        this.dialog.store.storeTotal = total;

        if (this.dialog.selected.selectedList && this.dialog.selected.selectedList.length > 0) {
          let storeCodeList = this.dialog.selected.selectedList.map(v => {
            return v.storeCode
          });
          this.dialog.store.storeList.forEach(v => {
            setTimeout(() => {
              if (storeCodeList.includes(v.storeCode)) {
                this.$refs.storeListTable.toggleRowSelection(v, true);
              }
            }, 0);
          })
        }
      }
    },
    selectdStore() {
      let list = JSON.parse(JSON.stringify(this.dialog.store.storeSelection))
      list.forEach(v => {
        v.shareRatio = "";
      })
      this.dialog.selected.selectedList = this.dialog.selected.selectedList.concat(list);
      this.dialog.selected.selectedList = arrayUnique2(
          this.dialog.selected.selectedList,
          "storeCode"
      );
      this.$refs.selectedTable.toggleAllSelection();
    },
    selectedHandleSelectionChange(val) {
      this.dialog.selected.selectedSelection = val;
    },
    storeHandleSelectionChange(val) {
      this.dialog.store.storeSelection = val;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async addStoreShare() {
      await this.queryStoreList();
      this.dialogVisible = true;
    },
    changeAccountType() {
      this.$confirm('此操作将修改供货商账户类型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.editSupplierAccountType();
      }).catch(() => {
        this.accountType = this.currentAccountType;
      });
    },
    async editSupplierAccountType() {
      let params = {
        storeCode: this.$route.query.storeCode,
        accountType: this.accountType
      }
      await this.$store.dispatch("editSupplierAccountType", params);
      this.$message({
        message: " 操作成功",
        type: "success"
      });
      this.currentAccountType = this.accountType;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        supplierCode: this.$route.query.storeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryStoreShareConfigList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    selectedPaging(page) {
      this.dialog.selected.selectedCurrentPage = page;
      this.querySelectedList();
    },
    selectedHandleSizeChange(size) {
      this.dialog.selected.selectedCurrentPage = 1;
      this.dialog.selected.selectedPageSize = size;
      this.querySelectedList();
    },
    storePaging(page) {
      this.dialog.store.storeCurrentPage = page;
      this.queryStoreList();
    },
    storeHandleSizeChange(size) {
      this.dialog.store.storeCurrentPage = 1;
      this.dialog.store.storePageSize = size;
      this.queryStoreList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  padding: 20px;
  background-color: #ffffff;
  .bold {
    font-weight: bold;
  }
  .name-wrapper {
    font-size: 14px;
    color: #222222;
  }
  .desc-wrapper {
    font-size: 12px;
    color: #666666;
  }
}
.left-wrapper {
  width: 600px;
}
.centre-wrapper {
  width: 150px;
}
</style>
